import React from "react";
import logoWhite from '../images/logo-black.png';
import './footer.css';

export default function Footer() {

    return (
        <React.Fragment>
            <footer>
                <div class="container my-5">
                    <div class="footer-top">
                        <a href="index.html" class="footer-logo w--current">
                            <img src={logoWhite} alt="logo" className="logo-img" />
                        </a>
                    </div>
                    <div class="footer-middle">
                        <nav class="footer-menus">
                            <div class="footer-menu">
                                <span>BlockStar Chain</span>
                                <ul>
                                    <li><a rel="noreferrer" target="_blank" href="https://scan.blockstar.one/">Mainnet</a></li>
                                    <li><a rel="noreferrer" target="_blank" href="https://testnet-scan.blockstar.one/">TestNet</a></li>
                                    <li><a rel="noreferrer" target="_blank" href="https://blockstar.site/faucet">Faucet</a></li>
                                </ul>
                            </div>
                            <div class="footer-menu">
                                <span>BlockStar</span>
                                <ul>
                                    <li><a rel="noreferrer" target="_blank" href="https://blockstar.site">Website</a></li>
                                    <li><a rel="noreferrer" target="_blank" href="https://blockstar.software/">AI</a></li>
                                    <li><a rel="noreferrer" target="_blank" href="https://blockstar.social/">Social</a></li>
                                    <li><a rel="noreferrer" target="_blank" href="https://blockstar.site/nft">Marketplace</a></li>
                                </ul>
                            </div>
                            <div class="footer-menu">
                                <span>Social</span>
                                <ul>
                                    <li><a rel="noreferrer" target="_blank" href="https://blockstar.social/BlockStar_Official">BlockStar</a></li>
                                    <li><a rel="noreferrer" target="_blank" href="https://twitter.com/BlockStar_BST">Twitter</a></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="footer-bottom__container ">
                        <div class="copyright text-center">© Copyright {new Date().getFullYear()} BlockStar | All Rights Reserved.</div>
                    </div>
                </div>
            </footer>

        </React.Fragment>
    )
}
